(() => {
  'use strict';

  const rootSelector = '[data-dc-preorders-filter-root]';

  const interpolate = (template, values) =>
    Object.entries(values).reduce(
      (output, [placeholder, value]) => output.replaceAll(`__${placeholder}__`, String(value)),
      template || ''
    );

  const setFilter = (root, filter, label, options = {}) => {
    const buttons = Array.from(root.querySelectorAll('[data-dc-preorder-filter-button]'));
    const cards = Array.from(root.querySelectorAll('[data-dc-preorder-card]'));
    const grid = root.querySelector('[data-dc-preorder-grid]');
    const emptyState = root.querySelector('[data-dc-preorder-filter-empty]');
    const emptyHeading = root.querySelector('[data-dc-preorder-filter-empty-heading]');
    const status = root.querySelector('[data-dc-preorder-filter-status]');
    let visibleCount = 0;

    buttons.forEach((button) => {
      const selected = button.dataset.dcPreorderFilterButton === filter;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');

      if (selected && options.focus) {
        button.focus();
      }
    });

    cards.forEach((card) => {
      const matches = filter === 'all' || card.dataset.dcPreorderTcg === filter;
      card.hidden = !matches;

      if (matches) {
        visibleCount += 1;
      }
    });

    if (grid) {
      grid.hidden = visibleCount === 0;
    }

    const showFilteredEmpty = filter !== 'all' && visibleCount === 0;

    if (emptyState) {
      emptyState.hidden = !showFilteredEmpty;
    }

    if (emptyHeading && showFilteredEmpty) {
      emptyHeading.textContent = interpolate(root.dataset.dcFilterEmptyTemplate, { TCG: label });
    }

    if (status) {
      const countKey = visibleCount === 1 ? 'One' : 'Other';
      const scopeKey = filter === 'all' ? 'All' : 'Tcg';
      const template = root.dataset[`dcFilterStatus${scopeKey}${countKey}`];
      status.textContent = interpolate(template, { COUNT: visibleCount, TCG: label });
    }
  };

  const initializeRoot = (root) => {
    if (root.dataset.dcPreorderFiltersReady === 'true') {
      return;
    }

    const buttons = Array.from(root.querySelectorAll('[data-dc-preorder-filter-button]'));

    if (buttons.length === 0) {
      return;
    }

    root.dataset.dcPreorderFiltersReady = 'true';

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        setFilter(
          root,
          button.dataset.dcPreorderFilterButton,
          button.dataset.dcPreorderFilterLabel || button.textContent.trim()
        );
      });
    });

    const resetButton = root.querySelector('[data-dc-preorder-filter-reset]');

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        const allButton = buttons.find((button) => button.dataset.dcPreorderFilterButton === 'all');
        setFilter(root, 'all', allButton?.dataset.dcPreorderFilterLabel || '', { focus: true });
      });
    }

    const allButton = buttons.find((button) => button.dataset.dcPreorderFilterButton === 'all');
    setFilter(root, 'all', allButton?.dataset.dcPreorderFilterLabel || '');
  };

  const initializeWithin = (scope) => {
    const roots = [];

    if (scope.matches && scope.matches(rootSelector)) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots.push(...scope.querySelectorAll(rootSelector));
    }

    roots.forEach(initializeRoot);
  };

  if (window.DarkCollectablesPreorderFilters) {
    window.DarkCollectablesPreorderFilters.initializeWithin(document);
    return;
  }

  window.DarkCollectablesPreorderFilters = { initializeWithin };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
